module.exports = __webpack_public_path__ + "static/img/1.c279971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc/1.png
// module id = tFKr
// module chunks = 0